import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} sellsByHour
 * @returns {Workbook}
 */
export const exportExcel = async (
  sellsByHour,
  selectedStore,
  requestedDate
) => {
  const json = excelHelper.jsonToJson(
    [sellsByHour],
    [
      {
        name: "VENTAS HORA - DIA",
        props: [
          {
            inValue: "hour",
            outValue: "HORA",
          },
          {
            inValue: "total",
            outValue: "VENTAS TOTALES",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, requestedDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, requestedDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-ventas-por-hora_" +
        formatHelper.toDateYYMMDD(requestedDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-ventas-por-hora_" +
        formatHelper.toDateYYMMDD(requestedDate._d) +
        "_" +
        storeName.toLowerCase() +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByHour/excel.js